import { IconProps } from './IconProps';

export function ChevronDown(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M5.7002 8.22168L12 14.5859L18.2998 8.22168L19 8.92871L12 16L11.2998 15.293L5 8.92871L5.7002 8.22168Z" />
        </svg>
    );
}
